<template>
    <b-modal :visible="showAdminModal === 'addEditTechcenter'" size="lg" @hidden="hideModal" :lazy="true">
        <div slot="modal-title">
            <h4 class="modal-title" v-if="item">Изменить техцентр {{item.name}}</h4>
            <h4 class="modal-title" v-else>Добавить техцентр</h4>
        </div>
        <loading v-if="loading" :size="3" message="Сохраняем..."></loading>
        <form v-else сlass="form-horizontal">
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="form-group row" :class="{ 'has-danger': $v.newDataItem.name.$error }">
                        <label for="item-name" class="col-4 col-form-label">Название</label>
                        <div class="col-8">
                            <input class="form-control" type="text" id="item-name" v-model.trim="newDataItem.name" @input="$v.newDataItem.name.$touch()">
                            <span class="small help-block text-danger" v-if="$v.newDataItem.name.$error">Название обязательно должно быть указано, минимум {{$v.newDataItem.name.$params.minLength.min}} символа</span>
                        </div>
                    </div>
                    <div class="form-group row" :class="{ 'has-danger': $v.newDataItem.cityId.$error }">
                        <label class="col-4 form-control-label">Город</label>
                        <div class="col-8">
                            <multiselect
                                    :options="cities"
                                    :searchable="true"
                                    :close-on-select="true"
                                    :show-labels="false"
                                    v-model="selected.city"
                                    placeholder="Город не выбран"
                                    track-by="id" label="name"
                                    @input="changeCity"
                            >

                            </multiselect>
                            <span class="small help-block text-danger" v-if="$v.newDataItem.cityId.$error">Город обязательно должен быть указан</span>
                        </div>
                    </div>
                    <div class="form-group row" :class="{ 'has-danger': $v.newDataItem.address.$error }">
                        <label for="item-address" class="col-4 col-form-label">Адрес</label>
                        <div class="col-8">
                            <input class="form-control" type="text" id="item-address" v-model.trim="newDataItem.address" @input="changeAddress()">
                            <span class="small help-block text-danger" v-if="$v.newDataItem.address.$error">Адрес обязательно должн быть указан, минимум {{$v.newDataItem.address.$params.minLength.min}} символа</span>
                        </div>
                    </div>
                    <div class="form-group row" :class="{ 'has-danger': $v.newDataItem.phone.$error }">
                        <label for="user-phone" class="col-4 col-form-label">Номер телефона</label>
                        <div class="col-8">
                            <div class="input-group">
                                <span class="input-group-addon">+7</span>
                                <input class="form-control" type="text" id="user-phone" v-model.trim="newDataItem.phone" @input="$v.newDataItem.phone.$touch()">
                            </div>
                            <span class="small help-block text-danger" v-if="$v.newDataItem.phone.$error">Телефон обязателен и должен состоять из 10 цифр</span>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-4 form-control-label">График работы</label>
                        <div class="col-8">
                            <div class="row">
                                <div class="form-group col-6">
                                    <select class="form-control" v-model="newDataItem.workDateStart">
                                        <option v-for="item in workDates" :value="item.id">{{item.name}}</option>
                                    </select>
                                </div>
                                <div class="form-group col-6">
                                    <select class="form-control" v-model="newDataItem.workDateEnd">
                                        <option v-for="item in workDates" :value="item.id">{{item.name}}</option>
                                    </select>
                                </div>
                                <div class="form-group col-6">
                                    <select class="form-control" v-model="newDataItem.workTimeStart">
                                        <option v-for="item in workTimes" :value="item.id">{{item.name}}</option>
                                    </select>
                                </div>
                                <div class="form-group col-6">
                                    <select class="form-control" v-model="newDataItem.workTimeEnd">
                                        <option v-for="item in workTimes" :value="item.id">{{item.name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-4 form-control-label">Часовой пояс</label>
                        <div class="col-8">
                            <select class="form-control" v-model="newDataItem.tzOffset">
                                <option v-for="item in tzOffsets" :value="item.id">{{item.name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-4 form-control-label">Цвет</label>
                        <div class="col-8">
                           <color-picker  :value="color" @input="updateColorValue"></color-picker>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group row">
                        <label class="col-6 col-form-label">Активность техцентра</label>
                        <div class="col-6 text-right">
                            <label class="switch switch-lg switch-3d switch-primary mr-1">
                                <input v-model="newDataItem.enabled" type="checkbox" class="switch-input">
                                <span class="switch-label"></span>
                                <span class="switch-handle"></span>
                                <small v-if="newDataItem.enabled">включен</small>
                                <small v-else>выключен</small>
                            </label>
                        </div>
                    </div>
                    <div class="form-group row" :class="{ 'has-danger': $v.newDataItem.companyId.$error }">
                        <label class="col-4 form-control-label">Компания</label>
                        <div class="col-8">
                            <multiselect
                                    :options="companies"
                                    :searchable="true"
                                    :close-on-select="true"
                                    :show-labels="false"
                                    v-model="selected.company"
                                    placeholder="Компания не выбран"
                                    track-by="id" label="name"
                                    @input="changeCompany"
                                    @open="loadCompanies"
                                    :loading="loadingCompanies"
                            >
                            </multiselect>
                            <span class="small help-block text-danger" v-if="$v.newDataItem.companyId.$error">Компания обязательно должна быть указана</span>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-4 form-control-label">Пользователи</label>
                        <div class="col-8">
                            <multiselect
                                    :options="users"
                                    :searchable="true"
                                    :multiple="true"
                                    :close-on-select="true"
                                    :show-labels="false"
                                    v-model="selected.users"
                                    placeholder="Пользователи не заданы"
                                    track-by="id" label="fullname"
                                    @select="attachUser"
                                    @remove="detachUser"
                                    @open="loadUsers"
                                    :loading="loadingUsers"
                            >
                            </multiselect>
                        </div>
                    </div>
                    <div class="form-group row" :class="{ 'has-danger': $v.newDataItem.maxOrders.$error }">
                        <label for="item-maxOrders" class="col-4 col-form-label">Максимальное число заказов</label>
                        <div class="col-8">
                            <input class="form-control" type="number" id="item-maxOrders" v-model.trim="newDataItem.maxOrders" @input="$v.newDataItem.maxOrders.$touch()">
                            <span class="small help-block text-danger" v-if="$v.newDataItem.maxOrders.$error">Число заказов должно быть больше 0</span>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header">Условия сотрудничеста (комиссия в процентах)</div>
                        <div class="card-block">
                            <div class="form-group row" :class="{ 'has-danger': $v.newDataItem.commissionInstall.$error }">
                                <label for="item-commissionInstall" class="col-8 col-form-label">От установки</label>
                                <div class="col-4">
                                    <input class="form-control" type="number" id="item-commissionInstall" v-model.trim="newDataItem.commissionInstall" @input="$v.newDataItem.commissionInstall.$touch()">
                                    <span class="small help-block text-danger" v-if="$v.newDataItem.commissionInstall.$error">Число должно быть больше 0</span>
                                </div>
                            </div>
                            <div class="form-group row" :class="{ 'has-danger': $v.newDataItem.commissionReclamation.$error }">
                                <label for="item-commissionReclamation" class="col-8 col-form-label">От рекламации</label>
                                <div class="col-4">
                                    <input class="form-control" type="number" id="item-commissionReclamation" v-model.trim="newDataItem.commissionReclamation" @input="$v.newDataItem.commissionReclamation.$touch()">
                                    <span class="small help-block text-danger" v-if="$v.newDataItem.commissionReclamation.$error">Число должно быть больше 0</span>
                                </div>
                            </div>
                            <div class="form-group row" :class="{ 'has-danger': $v.newDataItem.commissionRetail.$error }">
                                <label for="item-commissionRetail" class="col-8 col-form-label">От продажи в розницу</label>
                                <div class="col-4">
                                    <input class="form-control" type="number" id="item-commissionRetail" v-model.trim="newDataItem.commissionRetail" @input="$v.newDataItem.commissionRetail.$touch()">
                                    <span class="small help-block text-danger" v-if="$v.newDataItem.commissionRetail.$error">Число должно быть больше 0</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group row" :class="{ 'has-danger': $v.newDataItem.link.$error }">
                        <label for="item-link" class="col-4 col-form-label">Ссылка на схему проезда</label>
                        <div class="col-8">
                            <input class="form-control" type="text" id="item-link" v-model.trim="newDataItem.link" @input="$v.newDataItem.link.$touch()">
                            <span class="small help-block text-danger" v-if="$v.newDataItem.link.$error">Обязательно укажите ссылку на
                        <a href="https://maps.yandex.ru" target="_blank">Яндекс.Картах</a>,
                        <a href="https://www.google.ru/maps" target="_blank">Google Картах</a>
                        или  <a href="https://2gis.ru/" target="_blank">2 Gis</a>
                        </span>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="item-description" class="col-4 col-form-label">Описание проезда</label>
                        <div class="col-8">
                            <textarea class="form-control" type="text" id="item-description" v-model.trim="newDataItem.description" placeholder="Введите описание схемы проезда"></textarea>
                        </div>
                    </div>
                </div>
                <yandex-map
                        :coords="coords"
                        zoom="11"
                        style="width: 100%; height: 400px;"
                        :cluster-options="{
                                    1: {clusterDisableClickZoom: true}
                                  }"
                        map-type="map"
                        @map-was-initialized=""
                        :placemarks="placemarks"
                >
                </yandex-map>
            </div>
        </form>
        <div slot="modal-footer">
            <button v-if="!loading" :class="{ 'disabled': $v.newDataItem.$invalid }" :disabled="$v.newDataItem.$invalid" type="button" class="btn btn-success" @click.prevent="beforeUpdateForm">
                <template v-if="item">Сохранить изменения</template>
                <template v-else>Добавить техцентр</template>
            </button>
        </div>
    </b-modal>
</template>
<script>
  import { required, minLength, url, numeric, maxLength } from 'vuelidate/lib/validators'
  import addTechcenterMutate from './../../gql/mutations/AddTechcenter.graphql'
  import updateTechcenterMutate from './../../gql/mutations/UpdateTechcenter.graphql'
  import getCompanies from './../../gql/queries/getCompanies.graphql'
  import getUsers from './../../gql/queries/getUsersForMultiselect.graphql'
  import { mapState, mapActions } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  import Multiselect from 'vue-multiselect'
  import { workDates } from './../../helpers/workDates'
  import workTimes from './../../helpers/workTimes'
  import tzOffsets from './../../helpers/tzOffsets'
  import moment from 'moment'
  import { Sketch } from 'vue-color'
  export default {
    computed: {
      ...mapState({
        showAdminModal: state => state.adminStore.showModal,
        item: state => state.adminStore.editTechcenter,
        cities: state => state.globalStore.cities
      }),
      color () {
        return {
          hex: this.newDataItem.color
        }
      }
    },
    watch: {
      showAdminModal: function (val) {
        if (val === 'addEditTechcenter' && this.item) {
          this.setNewDataItem()
        }
        if (val === 'addEditTechcenter' && !this.item) {
          this.clearData()
        }
      }
    },
    data () {
      return {
        loading: false,
        newDataItem: {},
        coords: [55.751242, 37.620686],
        loadingCompanies: false,
        loadingUsers: false,
        companies: [],
        users: [],
        workDates: workDates(),
        workTimes: workTimes(),
        tzOffsets: tzOffsets(),
        selected: {
          city: null,
          company: null,
          users: []
        },
        placemarks: [{
          coords: [55.751242, 37.620686],
          options: { draggable: true },
          callbacks: { dragend: this.setNewCoord }
        }]
      }
    },
    methods: {
      setNewDataItem () {
        const item = this.item
        this.selected = {
          city: item.city,
          company: item.company,
          users: item.users
        }
        this.newDataItem = Object.assign({}, item)
        delete this.newDataItem.city
        delete this.newDataItem.company
        this.newDataItem.cityId = item.city.id
        this.newDataItem.companyId = item.company.id
        let coords = this.item.coords.split(', ')
        this.coords = [parseFloat(coords[0]), parseFloat(coords[1])]
        this.placemarks.splice(0, 1, {
          coords: [coords[0], coords[1]],
          options: { draggable: true },
          callbacks: { dragend: this.setNewCoord }
        })
        this.newDataItem.users = []
        item.users.forEach((user) => {
          this.newDataItem.users.push(user.id)
        })
        this.newDataItem.workTimeEnd = moment(item.workTimeEnd, 'HH:mm').format('HH:mm:ss').toString()
        this.newDataItem.workTimeStart = moment(item.workTimeStart, 'HH:mm').format('HH:mm:ss').toString()
      },
      beforeUpdateForm () {
        this.$v.newDataItem.$touch()
        if (this.$v.newDataItem.$error) {
          return
        }
        if (this.item) {
          this.updateItem()
        } else {
          this.addItem()
        }
      },
      addItem () {
        this.loading = true
        this.$apollo.mutate({
          mutation: addTechcenterMutate,
          variables: this.newDataItem
        }).then((data) => {
          this.loading = false
          this.addToast({
            text: 'Техцентр успешно добавлен',
            type: 'success',
            dismissAfter: 3000
          })
          this.hideModal()
        }).catch((error) => {
          console.error(error)
          this.addToast({
            text: 'Произошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
          this.loading = false
        })
      },
      updateItem () {
        this.loading = true
        this.$apollo.mutate({
          mutation: updateTechcenterMutate,
          variables: this.newDataItem
        }).then((result) => {
          this.loading = false
          this.addToast({
            text: 'Техцентр успешно обновлен',
            type: 'success',
            dismissAfter: 3000
          })
          if (this.$route.name === 'Techcenter') {
            this.$store.commit('SET_TECHCENTER', result.data.updateTechcenter)
          }
          this.hideModal()
        }).catch((error) => {
          console.error(error)
          this.addToast({
            text: 'Произошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
          this.loading = false
        })
      },
      hideModal () {
        this.clearData()
        this.$store.commit('SET_ADMIN_EDIT_TECHCENTER', null)
        this.$store.dispatch('setAdminModal', false)
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      }),
      clearData () {
        this.newDataItem = {
          id: null,
          name: '',
          enabled: true,
          cityId: null,
          companyId: null,
          address: '',
          link: '',
          color: '#000000',
          users: [],
          workDateStart: 1,
          workDateEnd: 7,
          workTimeStart: '10:00:00',
          workTimeEnd: '20:00:00',
          commissionReclamation: 40,
          commissionInstall: 40,
          commissionRetail: 50,
          maxOrders: 2,
          tzOffset: 'Europe/Moscow',
          description: '',
          coords: ''
        }
        this.$v.newDataItem.$reset()
        this.selected = {
          city: null,
          company: null,
          users: []
        }
        this.coords = [55.751242, 37.620686]
        this.placemarks.splice(0, 1, {
          coords: [55.751242, 37.620686],
          options: { draggable: true },
          callbacks: { dragend: this.setNewCoord }
        })
      },
      /**
       * Подргрузка Компаний
       * активируется при открытии селекта
       */
      loadCompanies () {
        this.loadingCompanies = true
        this.$apollo.query({
          query: getCompanies,
          variables: {
            all: true
          }
        }).then(result => {
          this.companies = result.data.companies
          this.loadingCompanies = false
        }).catch(error => {
          console.log(error)
          this.loadingCompanies = false
        })
      },
      changeCity (city) {
        if (city) {
          this.newDataItem.cityId = city.id
        } else {
          this.newDataItem.cityId = null
        }
        this.$v.newDataItem.cityId.$touch()
        this.setMapCoordsByAddress()
      },
      changeCompany (company) {
        if (company) {
          this.newDataItem.companyId = company.id
        } else {
          this.newDataItem.companyId = null
        }
        this.$v.newDataItem.companyId.$touch()
      },
      /**
       * Подргрузка менеджеров
       * активируется при открытии селекта
       */
      loadUsers () {
        this.loadingUsers = true
        this.$apollo.query({
          query: getUsers
        }).then(result => {
          this.users = result.data.users
          this.loadingUsers = false
        }).catch(error => {
          console.log(error)
          this.loadingUsers = false
        })
      },
      attachUser (user) {
        this.newDataItem.users.push(user.id)
      },
      detachUser (user) {
        let index = this.newDataItem.users.indexOf(user.id)
        this.newDataItem.users.splice(index, 1)
      },
      updateColorValue (value) {
        this.newDataItem.color = value.hex
      },
      setNewCoord (e) {
        let thisPlacemark = e.get('target')
        let coords = thisPlacemark.geometry.getCoordinates()
        this.newDataItem.coords = +coords[0] + ', ' + coords[1]
      },
      changeAddress () {
        this.$v.newDataItem.address.$touch()
        this.setMapCoordsByAddress()
      },
      setMapCoordsByAddress () {
        let city = this.selected.city.name
        let address = this.newDataItem.address
        let url = 'https://geocode-maps.yandex.ru/1.x/?format=json&sco=latlong&geocode=' + city + ' ' + address
        this.$http.get(url).then((response) => {
          let coords = response.data.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos.split(' ')
          coords = coords.map((coord) => {
            return parseFloat(coord)
          })
          this.coords = [coords[1], coords[0]]
          this.placemarks.splice(0, 1, {
            coords: [coords[1], coords[0]],
            options: { draggable: true },
            callbacks: { dragend: this.setNewCoord }
          })
          this.newDataItem.coords = +coords[1] + ', ' + coords[0]
        }).catch((error) => {
          console.log(error)
          this.addToast({
            text: 'Ошибка при загрузке карты: ' + error,
            type: 'danger',
            dismissAfter: 3000
          })
          this.loadingMap = false
        })
      }
    },
    created () {
      this.clearData()
    },
    components: {
      Multiselect,
      'color-picker': Sketch
    },
    validations: {
      newDataItem: {
        name: {
          required,
          minLength: minLength(2)
        },
        cityId: {
          required
        },
        companyId: {
          required
        },
        address: {
          required,
          minLength: minLength(2)
        },
        phone: {
          required,
          numeric,
          maxLength: maxLength(10),
          minLength: minLength(10)
        },
        link: {
          required,
          url
        },
        maxOrders: {
          required,
          numeric
        },
        commissionReclamation: {
          required,
          numeric
        },
        commissionInstall: {
          required,
          numeric
        },
        commissionRetail: {
          required,
          numeric
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ModalAdminAddEditTechcenter.vue?4c55c7a6